export default __webpack_public_path__ + "static/media/price_sign.08068ccd.svg";